
        'use strict';
        import { Component,  Input, OnInit, Inject} from 'ng-metadata/core';
        import {getViewSvg} from "../appConfig/customizationConfig";

        const some = require('lodash/some');

        @Component({
            selector: 'prm-icon',
            templateUrl: 'components/icon/icon.html',
            legacy: {transclude: true}
        })

        export class PrmIcon implements OnInit {
            @Input() private class:string;
            @Input() private iconType:string;
            @Input() private iconDefinition:string;
            @Input() private svgIconSet:string;
            @Input() private prmAriaLabel:string;
            @Input() private ariaLabel:string;
            @Input() public displayMode:string;
            @Input() private fallBackDefinition:string;
            private isCustom = false;
            private useFallBack = false;
            
            //keep the $element here - customers are using to customize their icons as a hack
            constructor(@Inject('$element') private $element: JQuery,
                        @Inject('$mdIcon') private $mdIcon) {
            }

            private async init() {
                try {
                    if (this.iconDefinition && getViewSvg()) {
                        let id: string = 'custom-ui:' + this.iconDefinition;
                        let iconEl = await this.$mdIcon(id).catch(angular.noop);
                        this.isCustom =  iconEl ? true : false;
                    }
                    if (!this.isCustom && this.fallBackDefinition ) {
                        let id: string = this.svgIconSet + ':' + this.iconDefinition;
                        let iconEl = await this.$mdIcon(id).catch(angular.noop);
                        this.useFallBack = iconEl ? false : true;
                    }
                 }catch(error){
                     console.error('failed to load icon');
                 }   
            }


            ngOnInit(){
                this.init();
            }

            public isEmailMode() {
                return this.displayMode === 'email';
            }

        }


// WEBPACK FOOTER //
// ./src/main/webapp/components/icon/icon.directive.ts